import Card from "@mui/material/Card";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";

import { useEffect, useState } from "react";
import { PASSWORD_REGEX } from "constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import buildingsBehindCloudsImage from "assets/images/buildings-behind-clouds.svg";
import { changePassword } from "services/authService";

function Cover() {
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  // Store email and otp in sessionStorage on first load
  useEffect(() => {
    const email = searchParams.get("email");
    const otp = searchParams.get("otp");

    if (email && otp) {
      sessionStorage.setItem("resetEmail", email);
      sessionStorage.setItem("resetOtp", otp);
      // Remove the query params from the URL
      setSearchParams({});
    }

    // Cleanup: Remove stored values when user navigates away
    return () => {
      sessionStorage.removeItem("resetEmail");
      sessionStorage.removeItem("resetOtp");
    };
  }, []);

  const handleChangePassword = () => {
    const email = sessionStorage.getItem("resetEmail");
    const otp = sessionStorage.getItem("resetOtp");

    if (!email || !otp) {
      toast.error("Session expired or missing parameters.");
      return;
    }

    if (!password || !confirmPassword) {
      toast.error("Required All Fields");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Password and Confirm Password must be same");
      return;
    }

    if (!password.match(PASSWORD_REGEX)) {
      toast.error(
        "Password must be atleast 8 characters and include a letter, number, and symbol"
      );
      return;
    }

    changePassword(password, email, otp)
      .then(() => {
        toast.success("Password changed successfully");
        // Clear session storage
        sessionStorage.removeItem("resetEmail");
        sessionStorage.removeItem("resetOtp");
        navigate("/user/login");
      })
      .catch(() => {
        toast.error("Something went wrong");
      });
  };

  return (
    <CoverLayout
      image={buildingsBehindCloudsImage}
      imgPosition="top"
      button={{ color: "info" }}
    >
      <Card>
        <ToastContainer />
        <ArgonBox p={3}>
          <ArgonBox display="flex" justifyContent="center">
            <ArgonBox textAlign="center">
              <ArgonTypography
                variant="h4"
                fontWeight="bold"
                color="primary"
                textAlign="center"
              >
                Reset Password
              </ArgonTypography>
              <ArgonTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                Create new password for your account
              </ArgonTypography>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
        <ArgonBox p={3}>
          <ArgonBox component="form" role="form">
            <ArgonBox mb={2}>
              <ArgonTypography
                display="block"
                variant="caption"
                fontWeight="bold"
                color="dark"
                sx={{ ml: 0.5, mb: 1 }}
              >
                Password
              </ArgonTypography>
              <ArgonInput
                type="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </ArgonBox>
            <ArgonBox mb={2}>
              <ArgonTypography
                display="block"
                variant="caption"
                fontWeight="bold"
                color="dark"
                sx={{ ml: 0.5, mb: 1 }}
              >
                Confirm Password
              </ArgonTypography>
              <ArgonInput
                type="password"
                placeholder="Confirm password"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </ArgonBox>

            <ArgonBox mt={3} mb={1} textAlign="center">
              <ArgonButton
                color="primary"
                onClick={handleChangePassword}
                sx={{ width: "30%" }}
              >
                Reset
              </ArgonButton>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
